import React from 'react';
import {View} from 'MWC';
import tpl from '../templates/platinum';
import CreditCardsModel from '../../models/creditCards.m';
import {apiback} from '../../../../config';
import widgetsHelper from 'utils/getWidget.helper';

const platinumCard = 'platinum_card';

export default class extends View {
    templates = {
        [this.uiStates.INITIAL]: <div />,
        [this.uiStates.INTERACTIVE]: tpl,
        [this.uiStates.ERROR]: tpl,
        [this.uiStates.STANDBY]: tpl
    };

    constructor(props) {
        super(props);

        this.state = {
            ui: this.uiStates.INITIAL,
            model: {},
            showModal: false,
            activeTab: 'visa',
            mode: 'info',
            where_by: ['path'],
            search_by: [location.pathname],
            widgets: [],
            loader: true
        };

        this.widgetsHelper = widgetsHelper;
        this.toggleNav = this.toggleNav.bind(this);
        this.toggleModal = this.toggleModal.bind(this);
        this.toggleMode = this.toggleMode.bind(this);

        this.crefs = {};

        return this;
    }

    toggleNav(event) {
        this.setState({activeTab: event.target.name});
    }

    toggleModal() {
        this.setState({showModal: !this.state.showModal});
    }

    toggleMode = mode => {
        this.setState({mode: mode});
    };

    componentWillMount() {
        this.props.setBlackTheme(true);
        this.widgetsHelper.getWidgets.call(this);
        fetch(apiback('CREDIT_CARDS'))
            .then(res => res.json())
            .then(json =>
                this.setState({
                    model: new CreditCardsModel(json.data[platinumCard])
                })
            );
        // .catch(x => console.log('error:', x)); //todo добавить обработчик
    }

    static displayName = 'CardPlatinum';
}
